import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { AnnotationService } from '../../service/annotation.service';
import { ToastService } from '../../service/toast.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { SearchService } from '../../service/search.service';
import { FinderData, AdminSearch } from '../../model/search';
import { Tchekb } from '../../model/tchekb.model';
import { Subscription } from 'rxjs';
import { Damage } from '../../model/damage.model';
import { ClassificationService } from '../../service/classification.service';
import { LocalstorageService } from '../../service/localstorage.service';
import { NgbModalRef, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ImagesService } from '../../service/images.service';
import { TchekService } from '../../service/tchek.service';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { fabric } from 'fabric_gesture';

@Component({
  selector: 'app-new-tchek',
  templateUrl: './new-tchek.component.html',
  styleUrls: ['./new-tchek.component.less']
})
export class NewTchekComponent implements OnInit {

  @ViewChild('content') content: ElementRef;

  closeResult: string;
  modalRef: NgbModalRef;
  saving: boolean = false
  files: File[] = [];
  immat: string
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  constructor(
    private ng2ImgMaxService: Ng2ImgMaxService,
    private modalService: NgbModal,
    private _annotationService: AnnotationService,
    private readonly _toastService: ToastService,
    private readonly _router: Router,
    private _route: ActivatedRoute,
    private readonly _tchekService: TchekService,
    private readonly _imageService: ImagesService,
    private readonly _searchService: SearchService,
    private readonly _classificationService: ClassificationService,
    private _localStorageService: LocalstorageService) { }


  ngOnInit() {
  }

  getImageDimensions(file) {
    return new Promise(function (resolved, rejected) {
      var i = new Image()
      i.onload = function () {
        resolved({ width: i.width, height: i.height })
      };
      i.src = file
    })
  }

  async saveTchek() {
    if (this.immat) {
      this.immat = this.immat.toLocaleUpperCase()
      this.saving = true
      try {
        let tchekId = await this._tchekService.newExternalTchek(this.immat)
        for await (const file of this.files) {
          await this._imageService.saveImages2(file, tchekId).catch(err => { console.log(err); })
        }
        this.modalRef.close("Saved click")
      } catch (error) {
        console.log(error);
      }
    }
  }



  openmodal() {
    this.files = []
    this.saving = false
    this.immat = undefined
    this.modalRef = this.modalService.open(this.content, { backdropClass: 'backdropClassModal' });
    this.modalRef.result.then((result) => {
      console.log('result', result);
    }, (reason) => {
      this.files = []
      this.immat = undefined
      this._classificationService.active = false
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/element/new-tchek/new-tchek.component.ts